export enum BroadcastBuilderTabType {
  BROADCAST = 'broadcast',
  SETTINGS = 'settings',
}
